<template>
  <div class="inline-cta">
    <h2>{{ title }}</h2>
    <div class="flex">
      <b-form-input
        v-model="email"
        :state="emailState"
        type="email"
        placeholder="Email address"
      />
      <b-form-input
        :id="formId"
        v-model="password"
        :state="passwordState"
        type="password"
        placeholder="Password"
      />
      <!-- <b-form-invalid-feedback :id="formfeedbackId">
        Enter at least 6 letters
      </b-form-invalid-feedback> -->
      <button
        class="primary-button primary"
        @click="submit"
      >
        {{ cta }}
      </button>
    </div>
    <div class="tc-wn">
      <b-form-checkbox
        :id="generateUuid()"
        v-model="terms_accepted"
        name="terms-and-conditions"
        unchecked-value="not_accepted"
      >
        I accept the
        <router-link to="/general-terms-and-conditions">
          Ludimos Terms &amp; Conditions
        </router-link>
      </b-form-checkbox>
      <!-- <b-form-checkbox
        id="weekly-newsletter"
        v-model="newsletter_optin"
        name="weekly-newsletter"
        unchecked-value="not_accepted"
      >
        I want to recieve newsletters
      </b-form-checkbox> -->
    </div>
  </div>
</template>

<script>
import AuthService from "@/services/auth";
import SIB from "@/services/SendInBlueService";
import uuid from 'uuid/v4';
export default {
  name: "SignUpForm",
  props: {
    title: { type: String, required: true },
    cta: { type: String, required: true },
    type: { type: String, required: true }
  },
  data() {
    return {
      formId: uuid(),
      terms_accepted: false, 
      newsletter_optin: true,
      email: "",
      password: "",
    };
  },
  computed: {
    formfeedbackId(){
      return `${this.formId}-feedback`;
    },
    emailState() {
      return !this.email ? null : this.validEmail(this.email);
    },
    passwordState() {
      if (this.password.length === 0) {
        return null;
      } else {
        return this.password.length < 6 ? false : true;
      }
    },
  },
  methods: {
    generateUuid(){
    return uuid()
    },
    redirect() {
      this.$ma.trackEvent({
        fb_event: "CompleteRegistration",
        category: "CompleteRegistration",
        action: "signup",
        label: this.type,
        type: this.type,
      });
      this.$gtm.trackEvent({ 
        event: "CompleteRegistration",
        category: "CompleteRegistration",
        action: "signup",
        label: this.type,
        value: "0",
       })

      // this.trackEvent("CompleteRegistration", "user", "signup", "success", this.type, "");
      this.$log.info('Creating user: ', this.email);
      SIB.createContact({ email: this.email }, [243]);
      window.open(
        `${process.env.VUE_APP_APP_BASE_URL}/user-verification?email=${this.email}`
      );
    },

    async submit() {
            if (!this.email || !this.validEmail(this.email)) {
        this.$bvToast.toast("Please enter a valid email address.", {
          title: "Invalid email",
          variant: "danger",
          solid: true,
          toaster: "b-toaster-top-center",
          autoHideDelay: "3000",
        });
        return;
      }
      if (!this.password || this.password.length < 6) {
        this.$bvToast.toast("Password should be at least 6 characters.", {
          title: "Password error",
          variant: "danger",
          solid: true,
          toaster: "b-toaster-top-center",
          autoHideDelay: "3000",
        });
        return;
      }
      if (!this.terms_accepted) {
        this.$bvToast.toast("Please accept our Terms & Conditions", {
          title: "T&C Error",
          variant: "danger",
          solid: true,
          toaster: "b-toaster-top-center",
          autoHideDelay: "3000",
        });
        return;
      }

      const response = await AuthService.signup(
        this.email,
        this.password,
        this.terms_accepted, 
        this.newsletter_optin,
        this.$route.query
      );
      if (response.status === 201) {
        this.redirect();
      } else {
        this.$bvToast.toast("Error while signing you up! Try again later.", {
          title: "Signup Error",
          variant: "danger",
          solid: true,
          toaster: "b-toaster-top-center",
          autoHideDelay: "3000",
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.tc-wn {
  text-align: left;
  margin-top: -5px;
  .custom-control {
    display: inline;
    margin: 0 10px 0 0;
  }
}
.inline-cta {
  background: #fff;
  padding: 50px;
  color: #2b3060;
  text-align: center;
  border-radius: 4px;

  h2 {
    margin-bottom: 30px;
  }
  input {
    margin: 0 20px 0 0;
  }
}

.primary-button {
  min-width: 300px;
}

@media (max-width: 767px) {
  .inline-cta {
    padding: 20px;
    input {
      margin: 20px 0;
    }
  }
  .flex {
    display: block;
    &.image {
      display: flex;
    }
  }
  .primary-button {
    min-width: 100%;
  }
  .tc-wn {
    margin-top: 10px;
    .custom-control {
      display: inline-block;
      margin: 10px 0 0 0;
    }
  }
}
</style>
